import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, vShow as _vShow, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-156db85a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "main-content" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-lg text-left" }, "Audio Sentiment Analysis", -1))
const _hoisted_4 = { class: "upload" }
const _hoisted_5 = { class: "relative block" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-gray-400" }, "Upload audio", -1))
const _hoisted_7 = ["disabled"]
const _hoisted_8 = {
  key: 0,
  class: "drop flex justify-center items-center w-full"
}
const _hoisted_9 = {
  for: "dropzone-file",
  class: "flex flex-col justify-center items-center w-full h-32 bg-gray-50 rounded-lg border-2 border-gray-300 border-dashed cursor-pointer dark:hover:bg-bray-800 dark:bg-gray-700 hover:bg-gray-100 dark:border-gray-600 dark:hover:border-gray-500 dark:hover:bg-gray-600"
}
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<div class=\"flex flex-col justify-center items-center pt-5 pb-6\" data-v-156db85a><svg aria-hidden=\"true\" class=\"mb-3 w-10 h-10 text-gray-400\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" data-v-156db85a><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12\" data-v-156db85a></path></svg><p class=\"mb-2 text-sm text-gray-500 dark:text-gray-400\" data-v-156db85a><span class=\"font-semibold\" data-v-156db85a>Click to upload media file</span></p><p class=\"text-xs text-gray-500 dark:text-gray-400\" data-v-156db85a> .mp3 </p></div>", 1)
const _hoisted_11 = {
  key: 1,
  class: "bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative",
  role: "alert"
}
const _hoisted_12 = { class: "font-bold mr-3" }
const _hoisted_13 = { class: "block sm:inline" }
const _hoisted_14 = { class: "absolute top-0 bottom-0 right-0 px-4 py-3" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("title", null, "Close", -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", { d: "M14.348 14.849a1.2 1.2 0 0 1-1.697 0L10 11.819l-2.651 3.029a1.2 1.2 0 1 1-1.697-1.697l2.758-3.15-2.759-3.152a1.2 1.2 0 1 1 1.697-1.697L10 8.183l2.651-3.031a1.2 1.2 0 1 1 1.697 1.697l-2.758 3.152 2.758 3.15a1.2 1.2 0 0 1 0 1.698z" }, null, -1))
const _hoisted_17 = [
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = { key: 2 }
const _hoisted_19 = { class: "w-full bg-gray-200 rounded-full dark:bg-gray-700" }
const _hoisted_20 = {
  key: 3,
  class: "flex flex-col"
}
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  disabled: "",
  type: "button",
  class: "processing-loader text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center mr-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800 inline-flex items-center"
}, [
  /*#__PURE__*/_createElementVNode("svg", {
    role: "status",
    class: "inline mr-3 w-4 h-4 text-white animate-spin",
    viewBox: "0 0 100 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      d: "M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z",
      fill: "#E5E7EB"
    }),
    /*#__PURE__*/_createElementVNode("path", {
      d: "M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z",
      fill: "currentColor"
    })
  ]),
  /*#__PURE__*/_createTextVNode(" Performing sentiment analysis... ")
], -1))
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "text-xs mt-3" }, "Processing may take up to 10 minutes. You can view the results later below.", -1))
const _hoisted_23 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("label", _hoisted_5, [
          _hoisted_6,
          _withDirectives(_createElementVNode("input", {
            disabled: _ctx.processingInProgress,
            class: "placeholder:italic placeholder:text-slate-400 block bg-white w-full border border-slate-300 rounded-md py-2 pl-3 pr-3 shadow-sm focus:outline-none focus:border-sky-500 focus:ring-sky-500 focus:ring-1 sm:text-sm",
            placeholder: "First type the file name",
            type: "text",
            name: "search",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.userFileName) = $event))
          }, null, 8, _hoisted_7), [
            [_vModelText, _ctx.userFileName]
          ])
        ]),
        (!_ctx.processingInProgress && _ctx.userFileName.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("label", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("input", {
                  id: "dropzone-file",
                  type: "file",
                  class: "hidden",
                  accept: ".mp3",
                  onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.uploadFile && _ctx.uploadFile(...args)))
                }, null, 32)
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.errorMessage)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("strong", _hoisted_12, _toDisplayString(_ctx.errorTitle), 1),
              _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.errorMessage), 1),
              _createElementVNode("span", _hoisted_14, [
                (_openBlock(), _createElementBlock("svg", {
                  onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.clearErrorMessage && _ctx.clearErrorMessage(...args))),
                  class: "fill-current h-6 w-6 text-red-500",
                  role: "button",
                  xmlns: "http://www.w3.org/2000/svg",
                  viewBox: "0 0 20 20"
                }, _hoisted_17))
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.uploadProgressPercentage && _ctx.uploadProgressPercentage != 100)
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, " Uploading... "))
          : _createCommentVNode("", true),
        _withDirectives(_createElementVNode("div", _hoisted_19, [
          _createElementVNode("div", {
            class: "bg-blue-600 text-xs font-medium text-blue-100 text-center p-0.5 leading-none rounded-full",
            style: _normalizeStyle('width:' + _ctx.uploadProgressPercentage + '%')
          }, _toDisplayString(_ctx.uploadProgressPercentage) + "% ", 5)
        ], 512), [
          [_vShow, _ctx.uploadProgressPercentage && _ctx.uploadProgressPercentage != 100]
        ]),
        (_ctx.uploadProgressPercentage == 100 && _ctx.processingInProgress)
          ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
              _hoisted_21,
              _hoisted_22,
              (_ctx.processingInProgress)
                ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                    _createTextVNode(" While waiting for the results, you may check our "),
                    _createVNode(_component_router_link, {
                      class: "marketplace-link",
                      to: "/marketplace"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" marketplace offers!")
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}